import { Dropdown } from 'primereact/dropdown';
import { useContext } from 'react';
import { RegisterContext } from '../contexts/RegisterContext';
import { WishValidatorContext } from '../contexts/WishValidatorContext';


export const SedentaryGroup = ({ wish, index, handleChange }) => {
    const { sedentaryGroups } = useContext(RegisterContext);
    const { isSedGroupAuto } = useContext(WishValidatorContext);


    const selectedSchoolTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const streetSchoolTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.name}</div>
            </div>
        );
    };

    return (
        <div className="d-flex flex-wrap w-100 rounded gap-4 adv-checkbox px-4 py-2 justify-content-between">
            <label className="w-100">Група на уседналост</label>
            <Dropdown
                name="sedGroup"
                value={wish.sedGroup}
                className="col_school_dropdown prime-dropdown-heigth w-100"
                options={sedentaryGroups}
                optionLabel="name"
                filter
                placeholder='Изберете група на уседналост'
                valueTemplate={selectedSchoolTemplate}
                itemTemplate={streetSchoolTemplate}
                onChange={(e) => handleChange(e, index)}
                disabled={isSedGroupAuto[index]}
            />
        </div>
    )
}